import React, { memo, useCallback, useMemo } from 'react';
import { DfFooter } from '@danfoss/mosaic-react';
import { AppRoute } from '../../router/Routing';
import styles from './AppFooter.module.scss';
import runtimeConfig from '../../config/runtimeConfig';

type Props = {
    onOpenTerms: () => void;
};


const AppFooter: React.FC<Props> = memo(() => {

    const openCookies = useCallback(() => window.CookieConsent?.renew?.(), []);

    const handleCookiesClick = useCallback((event: Event) => {
        event.preventDefault();
        openCookies();
    }, [openCookies]);

    const disclaimerLinks = useMemo(() => ([
        {
            title: 'Privacy policy',
            url: runtimeConfig.privacyPolicyUrl,
            isExternal: true,
        },
        {
            title: 'Terms of use',
            url: runtimeConfig.termsOfUseUrl,
            isExternal: true,
        },
        {
            title: 'General Information',
            url: "https://www.danfoss.com/en/terms/generalinformation",
            isExternal: true,
        },
        {
            title: 'Cookies',
            url: '#cookies',
            linkProps: {
                onClick: handleCookiesClick,
            },
        },
    ]), [handleCookiesClick]);

    return (
        <div className={styles.footer}>
            <DfFooter
                disclaimersAriaLabel="Footer links"
                disclaimerLinks={disclaimerLinks}
                withCookiesButtonProps={{
                    onClick: openCookies,
                    type: 'button',
                }}
            />
        </div>
    );
});

export default AppFooter;
